const application = {
  platform: {
    name: 'Husleie.no',
    homePage: {
      URL: 'https://husleie.no/',
    },
  },
};

export { application };
